const faqData = {
  ADMIN: [
    {
      q: "Comment ajouter un utilisateur ?",
      a: "Allez dans Paramètres > Utilisateurs, cliquez sur 'Ajouter un utilisateur'. Remplissez les champs (email, mot de passe, nom, prénom, rôle). Pour un étudiant, utilisez les filtres année/filière/niveau pour lui associer son profil."
    },
    {
      q: "Comment importer des étudiants en masse ?",
      a: "Dans Paramètres > Utilisateurs, cliquez sur 'Importer JSON'. Vous pouvez aussi exporter les étudiants sans compte depuis la page Étudiants via le bouton 'Exporter JSON'."
    },
    {
      q: "Comment créer une inscription ?",
      a: "Allez dans la page Inscriptions, cliquez sur 'Nouvelle inscription'. Sélectionnez l'étudiant, l'année universitaire, la filière et le niveau."
    },
    {
      q: "Comment gérer les paiements ?",
      a: "Dans la page Paiements, utilisez les filtres pour trouver un étudiant. Vous pouvez définir le montant (33300 DH par défaut), ajouter des versements, et imprimer un reçu."
    },
    {
      q: "Comment ajouter une filière ?",
      a: "Dans Paramètres > Filières, cliquez sur 'Ajouter une filière'. Remplissez les informations (code, intitulé, diplôme, nombre d'années)."
    },
    {
      q: "Comment faire une passation ?",
      a: "Dans la page Passation, sélectionnez l'étudiant concerné, choisissez l'année/filière/niveau de destination, puis validez."
    },
    {
      q: "Comment modifier les permissions d'un rôle ?",
      a: "Dans Paramètres > Rôles, sélectionnez un rôle et cochez/décochez les permissions souhaitées."
    },
    {
      q: "Comment exporter des données ?",
      a: "Dans les pages Étudiants, Inscriptions, et Paiements, utilisez les boutons d'export (Excel, PDF, CSV)."
    }
  ],
  ENSEIGNANT: [
    {
      q: "Comment noter des étudiants ?",
      a: "Allez dans la page Notes, sélectionnez la matière, la filière et le niveau. Vous pouvez saisir les notes individuellement ou via un import CSV."
    },
    {
      q: "Comment faire l'appel ?",
      a: "Dans la page 'Faire l'appel', sélectionnez la séance (date, matière, groupe). Cocher les présents et validez."
    },
    {
      q: "Où voir mon emploi du temps ?",
      a: "Dans la page Emploi du Temps, vous pouvez voir votre planning par jour/semaine."
    },
    {
      q: "Comment consulter les informations d'un étudiant ?",
      a: "Dans la page Étudiants, utilisez la barre de recherche ou les filtres pour trouver un étudiant et voir ses détails."
    },
    {
      q: "Comment suivre les présences ?",
      a: "Dans la page Présences, vous pouvez voir l'historique des présences par étudiant, date ou matière."
    },
    {
      q: "Où voir les stages des étudiants ?",
      a: "Dans la page Stages, vous pouvez consulter et suivre les stages des étudiants."
    }
  ],
  ETUDIANT: [
    {
      q: "Comment voir mes notes ?",
      a: "Dans votre espace étudiant, la section Notes affiche toutes vos notes par matière et par semestre."
    },
    {
      q: "Comment voir mes paiements ?",
      a: "Dans votre espace étudiant, la section Paiements affiche le récapitulatif de vos frais de scolarité."
    },
    {
      q: "Comment voir mes présences ?",
      a: "Dans votre espace étudiant, la section Présences affiche votre historique de présence."
    },
    {
      q: "Où voir mon emploi du temps ?",
      a: "Dans la page Emploi du Temps, vous pouvez voir votre planning."
    },
    {
      q: "Comment contacter l'administration ?",
      a: "Utilisez la page Messages pour envoyer un message à l'administration ou à vos enseignants."
    },
    {
      q: "Comment modifier mon profil ?",
      a: "Cliquez sur votre avatar en haut à droite, puis 'Profile' pour voir vos informations."
    }
  ],
  CONSULTANT: [
    {
      q: "Comment consulter la liste des étudiants ?",
      a: "Allez dans la page Étudiants. Vous pouvez filtrer par année, filière, niveau, ou utiliser la recherche."
    },
    {
      q: "Comment voir les statistiques ?",
      a: "Le Dashboard affiche les indicateurs clés : nombre d'étudiants, inscriptions, CA ciblé/réalisé, etc."
    },
    {
      q: "Comment consulter les inscriptions ?",
      a: "Dans la page Inscriptions, utilisez les filtres pour voir les inscriptions par année, filière, niveau."
    },
    {
      q: "Comment voir les paiements ?",
      a: "Dans la page Paiements, vous pouvez consulter les paiements des étudiants et voir les statistiques."
    },
    {
      q: "Comment exporter des données ?",
      a: "Les pages Étudiants, Inscriptions et Paiements proposent des boutons d'export."
    }
  ],
  GENERAL: [
    {
      q: "Comment me déconnecter ?",
      a: "Cliquez sur votre avatar en haut à droite, puis 'Déconnexion', ou utilisez le bouton rouge dans le menu latéral."
    },
    {
      q: "Comment changer mon mot de passe ?",
      a: "Cliquez sur votre avatar en haut à droite, puis 'Paramètres' pour changer votre mot de passe."
    },
    {
      q: "L'application ne répond pas, que faire ?",
      a: "Essayez de rafraîchir la page (F5). Si le problème persiste, déconnectez-vous et reconnectez-vous. Contactez l'administrateur si besoin."
    },
    {
      q: "Comment signaler un bug ?",
      a: "Contactez l'administrateur via la page Messages ou par email."
    }
  ]
};

export default faqData;

